export class AccountingInterfaceModel {
  accountingInterfaceId: number = 0;
  branchId: number = 0;
  enterpriseId: number = 0;
  consecutive: number = 0; // Se llena en el backend
  active: boolean = true;
  bussinessDocumentsTypeId: number = 0;
  dateInterface: Date = new Date;
  observation: string | null = null;
  addDetailWithError: boolean = false;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  //variable para controlar si están limpiando el formulario:
  clearForm: boolean = true;
}